



































































import { Component, Prop, Watch } from 'vue-property-decorator';
import CommonVue from '@/models/commonVue';
import { BusEvent } from '@/models/bus';

import Module from '@/api/module';
import Topic from '@/api/topic';
import Skill from '@/api/skill';
import Program from '@/api/program';
import ApiList from '@/api/list';
import Category from '@/api/category';

import ArrowIcon from '@/components/icons/ArrowIcon.vue';
import ListEntity from '@/components/listView/ListEntity.vue';
import EditModule from '@/editComponents/EditModule.vue';
import EditProgram from '@/editComponents/EditProgram.vue';
import EditSkill from '@/editComponents/EditSkill.vue';
import EditTopic from '@/editComponents/EditTopic.vue';
import EditCategory from '@/editComponents/EditCategory.vue';
import EditProject from '@/editComponents/EditProject.vue';
import Project from '@/api/project';
import Dimmer from '@/components/Dimmer.vue';

@Component({
  components: {
    'list-entity': ListEntity,
    'arrow-icon': ArrowIcon,
    'edit-module': EditModule,
    'edit-program': EditProgram,
    'edit-skill': EditSkill,
    'edit-topic': EditTopic,
    'edit-category': EditCategory,
    'edit-project': EditProject,
    // 'edit-course': EditCourse,
    dimmer: Dimmer
  }
})
export default class EntityView extends CommonVue {
  @Prop({ type: String }) public entity!: string;
  @Prop() public id: number;
  @Prop({ type: Boolean, default: false }) public isEdit!: boolean;

  public projects?: Promise<ApiList<Project>> = undefined;
  public list?:
    | Promise<ApiList<Module>>
    | Promise<ApiList<Skill>>
    | Promise<ApiList<Topic>>
    | Promise<ApiList<Program>>
    | Promise<ApiList<Category>> = undefined;
  public isOrdering: boolean = false;
  public loading: boolean = false;

  public beforeMount() {
    this.getList();

    this.$bus.$on(BusEvent.CACHE_CHANGED, () => {
      this.getList();
    });
  }

  @Watch('entity')
  public getList() {
    switch (this.entity) {
      case this.MODULE_SLUG:
        this.list = Module.listAll();
        this.projects = Project.list();
        break;
      case this.SKILL_SLUG:
        this.list = Skill.listAll();
        break;
      case this.CATEGORY_SLUG:
        this.list = Category.listAll();
        break;
      case this.PROGRAM_SLUG:
        this.list = Program.listAll();
        break;
      default:
        this.list = Topic.listAll();
        
    }
  }
}
